import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormGroup, Input, Label, Form } from 'reactstrap';
import CardReactFormContainer from 'card-react';
import propTypes from 'prop-types';
import 'card-react/lib/card.css';

import { Container } from './style';
import Submit from '../../components/Submit';
import SuperLoading from '../../components/SuperLoading';

import { Creators as CreditCardCreators } from '../../store/ducks/creditCard';

class CreditCard extends PureComponent {
  static propTypes = {
    loading: propTypes.bool.isRequired,
    sandCard: propTypes.func,
    name: propTypes.string.isRequired,
    expiry: propTypes.string.isRequired,
    number: propTypes.string.isRequired,
    editable: propTypes.bool,
    className: propTypes.string.isRequired,
    showCard: propTypes.bool,
  };

  static defaultProps = {
    editable: true,
    showCard: true,
  };

  state = {
    name: 'Nome Sobrenome',
  };

  getCardData = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  clearName = () => {
    if (this.state.name !== 'Nome Sobrenome') return;
    this.setState({ name: '' });
  };

  goSubscription = (e) => {
    e.preventDefault();

    const {
      name, expiry, number, cvc,
    } = e.target;

    this.props.sandCard({
      holder_name: name.value,
      card_expiration: expiry.value,
      card_number: number.value,
      card_cvv: cvc.value,
    });
  };

  render() {
    const {
      loading, showCard, name, expiry, number, editable, className,
    } = this.props;

    return (
      <Container>
        <div
          id="card-wrapper"
          className={className || 'normal'}
          style={{ display: showCard && 'block' }}
        />
        <CardReactFormContainer
          container="card-wrapper"
          classes={{
            valid: 'valid-input',
            invalid: 'invalid-input',
          }}
          initialValues={{
            name,
            expiry,
            number,
          }}
          formatting
        >
          <Form onSubmit={this.goSubscription} style={{ display: !editable && 'none' }}>
            <FormGroup>
              <Label for="number">Número do cartão</Label>
              <Input
                placeholder="Número do Cartão"
                type="text"
                name="number"
                onChange={this.getCardData}
              />
            </FormGroup>
            <FormGroup>
              <Label for="Name">Nome impresso no cartão</Label>
              <Input
                placeholder="Nome no cartão"
                type="text"
                name="name"
                onChange={this.getCardData}
                onFocusCapture={this.clearName}
                value={name}
              />
            </FormGroup>

            <div className="form-row">
              <div className="form-group col-md-6">
                <Label for="expiry">Data de expiração</Label>
                <Input placeholder="MM/AA" type="text" name="expiry" onChange={this.getCardData} />
              </div>
              <div className="form-group col-md-6">
                <Label htmlFor="cvc">Código CVC</Label>
                <Input placeholder="CVC" type="text" name="cvc" onChange={this.getCardData} />
              </div>
            </div>
            <Submit loading={loading} name="Finalizar" className="btn-block" />
          </Form>
        </CardReactFormContainer>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.creditCard.loading,
});

const mapDispatchToProps = dispatch => bindActionCreators(CreditCardCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreditCard);



// WEBPACK FOOTER //
// ./src/components/CreditCard/index.js